import React from "react";
import { Select } from "antd";
import "./MultipleSelect.css"
const { Option } = Select;

const MultipleSelect = ({ titleName, initialItems, selectedItems, handleChange, width }) => {
    return <div className="multiple-select" style={{ width: width }}>
        <div className="multiple-Title">{titleName}</div>
        <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select items"
            onChange={handleChange}
            value={selectedItems}
        >
            {initialItems?.length > 0 && initialItems.map(ele => {
                return <Option key="1" value={ele.value}>
                    {ele.label}
                </Option>
            })}



        </Select>
    </div>
}

export default MultipleSelect